import { nodeToString } from './common';

// TODO: if all works fine - refactoring
export const printSvgToImage = (svgNode, options) => {
  const pixelWidth = +svgNode.getAttribute('width');
  const pixelHeight = +svgNode.getAttribute('height');
  const viewBoxData = svgNode.getAttribute('viewBox').split(' ');
  const mmWidth = +viewBoxData[2];
  const mmHeight = +viewBoxData[3];
  const svgString = nodeToString(svgNode);

  return svgString2Image({
    svgString,
    width: pixelWidth,
    height: pixelHeight,
    format: 'image/png',
    options
  }).then(renderedData => {
    renderedData.sizeMM = {
      w: renderedData.isRotatedSize ? mmHeight : mmWidth,
      h: renderedData.isRotatedSize ? mmWidth : mmHeight,
    };
    return renderedData;
  });
};

export const printSvg = (svgNode, options) => {
  const pixelWidth = +svgNode.getAttribute('width'),
    pixelHeight = +svgNode.getAttribute('height'),
    viewBoxData = svgNode.getAttribute('viewBox').split(' '),
    mmWidth = +viewBoxData[2],
    mmHeight = +viewBoxData[3];
  return new Promise((resolve, reject) => {
    resolve({
      isRotatedSize: false,
      size: { w: pixelWidth, h: pixelHeight },
      sizeMM: { w: mmWidth, h: mmHeight },
      imageUrlData: nodeToString(svgNode),
    });
  });
};

export const parseMatfilePrintTransforms = transforms => {
  const printTransforms = [];
  transforms.forEach(({ action, offset_central_point }) => {
    const resItem = { offsetCentralPoint: offset_central_point };
    switch (action) {
      case 'ROTATE_CW90':
        resItem['rotation'] = 90;
        break;
      case 'ROTATE_180':
        resItem['rotation'] = 180;
        break;
      case 'ROTATE_CCW90':
        resItem['rotation'] = 270;
        break;
      case 'MIRROR_X':
        resItem['mirrorX'] = true;
        break;
      case 'MIRROR_Y':
        resItem['mirrorY'] = true;
        break;
    }

    printTransforms.push(resItem);
  });

  return printTransforms;
};

const svgString2Image = async ({ svgString, width, height, format = 'image/bmp', options }) => {
  try {
    const DOMURL = self.URL || self.webkitURL || self;
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = DOMURL.createObjectURL(svgBlob);
    const loadImage = new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = (error) => reject(error);
      image.src = url;
    });
    const image = await loadImage;
    return new Promise((resolve) => {
      setTimeout(() => {
        const canvas = document.createElement('canvas');
        // use canvas as printer
        const context = canvas.getContext('2d');
        canvas.setAttribute('width', width);
        canvas.setAttribute('height', height);
        // set background (important before transformations)
        context.fillStyle = options?.fillStyle || 'white';
        context.fillRect(0, 0, width, height);
        context.drawImage(image, 0, 0);
        const imageUrlData = canvas.toDataURL(format);
        const renderedData = {
          isRotatedSize: false,
          size: { w: width, h: height },
          imageUrlData,
        };
        resolve(renderedData);
      }, 300);
    });
  } catch (error) {
    console.error('Error in svgString2Image:', error);
    throw error;
  }
};
